"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const client_ses_1 = require("@aws-sdk/client-ses");
const environment_ts_1 = require("../../../../service-lib/src/lib/environment.ts");
let EmailService = class EmailService {
    constructor() {
        this.sesClient = new client_ses_1.SESClient({
            region: environment_ts_1.ENV.AWS_REGION,
        });
    }
    async sendEmail(toAddress, ccAddress, subject, body) {
        const sendEmailCommand = new client_ses_1.SendEmailCommand({
            Destination: {
                CcAddresses: ccAddress,
                ToAddresses: toAddress,
            },
            Message: {
                Body: {
                    Html: {
                        Charset: 'UTF-8',
                        Data: body,
                    },
                    Text: {
                        Charset: 'UTF-8',
                        Data: body,
                    },
                },
                Subject: {
                    Charset: 'UTF-8',
                    Data: subject,
                },
            },
            Source: environment_ts_1.ENV.EMAIL_FROM,
        });
        try {
            return await this.sesClient.send(sendEmailCommand);
        }
        catch (e) {
            console.error('Failed to send email.', e);
            return e;
        }
    }
};
exports.EmailService = EmailService;
exports.EmailService = EmailService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [])
], EmailService);
